<script>
    import Vue from 'vue';
    import 'select2';
    import 'select2/dist/js/i18n/pt-BR';
    import DadosSolicitacao from './compartilhado/FormDadosSolicitacao.vue';
    import AdicionarItem from './compartilhado/FormAdicionarItem.vue';
    import AdicionarArquivos from '~componentes/FormAdicionarArquivos.vue';
    import ListaDeArquivos from '~componentes/ListaDeArquivos.vue';
    import ListaItem from './compartilhado/FormListaItens.vue';
    import Termo from './compartilhado/FormComprasOnlineTermo.vue';
    import VueSweetAlert from 'vue-sweetalert';
    import solicitacaoCompraServico from '../servico';

    Vue.use(VueSweetAlert);

    export default {
        components: { DadosSolicitacao, AdicionarItem, ListaItem, AdicionarArquivos, ListaDeArquivos, Termo },
        data() {
            return {
                configuracao: this.$storage.configuracao(),
                solicitacao: {
                    idConta: '',
                    idDetalheRateio: '',
                    alteracaoLocalEntrega: 0,
                    estado: '',
                    observacaoSolCompras: '',
                    itensSolicitacaoCompra: [],
                    aceite: '',
                    idSolicitacaoOrigem: 0,
                    observacaoCancelamento: '',
                    projeto: {
                        idProjeto: null,
                        nomeProjeto: null,
                        utilizarMetaEtapaProjeto: false,
                    }
                },
                carregando: false,
                arquivos: [],
            }
        },
        mounted() {
            this.carregarProjetos = this.$route.params.id ? false : true;

            this.$root.tituloDaPagina = `Solicitação de Compra - ${this.$route.params.id ? 'Editar #' + this.$route.params.id : 'Nova'}`;
            this.$root.botaoAcaoTexto = 'Nova';
            this.$root.botaoAcaoIcon = 'fa-plus';
            this.$root.botaoAcaoLink = 'solicitacao-compra.nova';

            if (!this.$route.params.id) {
                this.$events.emit('carregarProjetos');
            }

            this.mostrarInstrucoes();
        },
        created() {
            if (this.$route.params.id) {
                this.carregar(this.$route.params.id);
            }
        },
        methods: {
            salvar() {
                $('#salvar').button('loading');

                this.$refs.dadosSolicitacao
                    .validarDadosSolicitacao()
                    .then(valido => {
                        if (!valido) {
                            $('#tabs a[href="#tab-dados-solicitacao"]').tab('show');
                        }

                        return valido;
                    })
                    .then(this.validarSePossuiItens)
                    .then(this.validarTermoResponsabilidade)
                    .then(this.concatenarLocalEntrega)
                    .then(this.enviar)
                    .then(id => {
                        this.$imprimirRelatorio('solicitacao-compra.relatorio', id, 'solicitacao-compra');
                    })
                    .catch(erro => {
                        $('#salvar').button('reset');
                        this.$mensagemErro(erro, 'Erro ao salvar a solicitação.');
                    });
            },
            validarSePossuiItens(valido) {
                if (!valido) throw new Error("validacao com erro");

                if (this.solicitacao.itensSolicitacaoCompra.length > 0) return true;

                $('#tabs a[href="#tab-adicionar-itens"]').tab('show');

                this.$swal(
                    '',
                    'A solicitação deve possuir ao menos um item.',
                    'info'
                );

                throw new Error("validacao");
            },
            validarTermoResponsabilidade(valido) {
                if (!valido) throw new Error("validacao com erro");

                if (!this.habilitarOuDesabilitarTermo) return true;

                if (this.solicitacao.aceite) return true;

                $('#tabs a[href="#tab-termo"]').tab('show');

                this.$refs.termo.adicionaErroAceite();

                throw new Error("validacao");
            },
            enviar(valido) {
                if (!valido) throw new Error("validacao com erro");

                const copiaSolicitacao = JSON.parse(JSON.stringify(this.solicitacao));

                copiaSolicitacao.arquivosDeletados = this.$refs.listaArquivos.deletados;

                if (this.$route.params.id) {
                    return solicitacaoCompraServico.alterar(copiaSolicitacao, this.$refs.adicionarArquivos.arquivos, this.$route.params.idCript);
                } else {
                    return solicitacaoCompraServico.adicionar(copiaSolicitacao, this.$refs.adicionarArquivos.arquivos);
                }
            },
            mostrarInstrucoes() {
                if (!this.configuracao.instrucoesSolCompra || this.$route.params.id) return;

                this.$swal({
                    title: 'Instruções da solicitação',
                    html: this.configuracao.instrucoesSolCompra.replace(/\r\n/g, '<br>'),
                    type: 'info',
                    confirmButtonText: 'Ok, entendi!',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                });
            },
            concatenarLocalEntrega(valido) {
                this.solicitacao.localEntrega = [
                    this.solicitacao.endereco,
                    this.solicitacao.bairro,
                    this.solicitacao.cidade,
                    this.solicitacao.estado,
                    this.solicitacao.cep || '',
                ].join('=|=');

                return valido;
            },
            carregar(id) {
                this.carregando = true;

                let solicitacao = null;

                solicitacaoCompraServico
                    .obterPorId(id)
                    .then(dados => {
                        solicitacao = dados;
                    })
                    .then(() => this.$refs.dadosSolicitacao.listaContas(solicitacao.idProjeto))
                    .then(() => {
                        if (solicitacao.projeto.utilizarMetaEtapaProjeto) {
                            this.$events.emit('carregarMetaEtapas', solicitacao.idProjeto)
                        }

                        if (this.configuracao.exibirRubricaSubrubricaSolicitacaoWeb) {
                            this.$events.emit('carregarRubricas', solicitacao.idProjeto)
                        }

                        if (this.$route.params.id && this.configuracao.permitirApenasUmTipoItemSolicitacaoCompra && solicitacao.itensSolicitacaoCompra.length > 0) {
                            this.$set(this.$refs.adicionarItem.itemSolicitacao, 'tipoCompra', solicitacao.itensSolicitacaoCompra[0].tipoCompra);
                        }
                    })
                    .then(() => {
                        const localEntrega = solicitacao.localEntrega.split('=|=');

                        solicitacao.endereco = localEntrega[0];
                        solicitacao.bairro = localEntrega[1];
                        solicitacao.cidade = localEntrega[2];
                        solicitacao.estado = localEntrega[3];
                        solicitacao.cep = localEntrega[4];
                    })
                    .then(() => solicitacaoCompraServico.arquivos(id))
                    .then(arquivos => {
                        this.arquivos = arquivos;
                    })
                    .then(() => {
                        this.$set(this, 'solicitacao', solicitacao);
                        this.carregando = false;

                        if (this.$refs.adicionarItem) {
                            this.$refs.adicionarItem.setDesabilitarExecutora(this.solicitacao.itensSolicitacaoCompra);
                        }
                    });
            },
            cancelarClickDaTab(e) {
                if (!this.solicitacao.idProjeto) {
                    e.preventDefault();
                }
            },
            habilitarOuDesabilitarProjeto() {
                $('#projeto').prop('disabled', this.solicitacao.itensSolicitacaoCompra.length > 0);

                if (this.$refs.adicionarItem) {
                    this.$refs.adicionarItem.setDesabilitarExecutora(this.solicitacao.itensSolicitacaoCompra);
                }
            },            
            download(arquivo) {
                solicitacaoCompraServico
                    .download(this.$route.params.id, arquivo)
                    .then(arquivo => {
                        arquivo.download();
                    });
            },
            nl2br(str) {
              var breakTag = '<br>';
              return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
            },
            editarItem(indice) {
              if (this.$refs.adicionarItem) {
                this.$refs.adicionarItem.editarItem(this.solicitacao.itensSolicitacaoCompra[indice], indice);
                $('#tabs a[href="#tab-adicionar-itens"]').tab('show');
              }
            }
        },
        computed: {
          habilitarOuDesabilitarTermo() {
            return this.solicitacao.itensSolicitacaoCompra.find(i => i.tipoCompra == '13' && i.executora == '2');
          },
        },
        watch: {
            'solicitacao.itensSolicitacaoCompra.length': 'habilitarOuDesabilitarProjeto'
        },
        beforeDestroy() {
            this.$events.off('carregarProjetos');
            this.$events.off('carregarMetaEtapas');
            this.$events.off('limparEnderecoEntrega');
        }
    }
</script>

<template>
    <div :class="'wrapper wrapper-content animated ' + $root.animacaoPadrao">
        <form>

            <div class="row">
                <div class="col-xs-12">
                    <div class="ibox float-e-margins" v-if="carregando">
                        <div class="ibox-content">
                            <p class="text-center">
                                <i class='fa fa-spinner fa-pulse'></i> Carregando...
                            </p>
                        </div>
                    </div>

                    <div class="alert alert-warning" role="alert" v-show="solicitacao.observacaoCancelamento">
                        <div class="row">
                            <div class="col-xs-12">
                                <div class="form-group no-margins">
                                    <dl class="col-xs-12">
                                        <dt>Observação cancelamento</dt>
                                        <dd v-html="nl2br(solicitacao.observacaoCancelamento)">
                                            {{ nl2br(solicitacao.observacaoCancelamento) }}
                                        </dd>
                                    </dl>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="tabs-container" v-show="!carregando" id="tabs">

                        <ul class="nav nav-tabs">
                            <li class="active">
                                <a data-toggle="tab"
                                   href="#tab-dados-solicitacao">
                                    Dados da solicitação
                                </a>
                            </li>
                            <li :class="{'disabled': !solicitacao.idProjeto}">
                                <a :data-toggle="solicitacao.idProjeto ? 'tab' : ''"
                                   href="#tab-adicionar-itens"
                                   @click="cancelarClickDaTab">
                                    Adicionar itens
                                </a>
                            </li>
                            <li :class="{'disabled': !solicitacao.idProjeto}">
                                <a :data-toggle="solicitacao.idProjeto ? 'tab' : ''"
                                   href="#tab-itens-solicitacao"
                                   @click="cancelarClickDaTab">
                                    Itens da solicitação
                                </a>
                            </li>

                            <li v-if="habilitarOuDesabilitarTermo">
                                <a data-toggle="tab"
                                   href="#tab-termo">
                                    Termo de responsabilidade
                                </a>
                            </li>

                            <li v-if="configuracao.usarArquivosSolicitacaoCompras">
                                <a data-toggle="tab"
                                   href="#tab-adicionar-arquivos">
                                    Adicionar arquivos
                                </a>
                            </li>
                            <li v-if="$route.params.id && configuracao.usarArquivosSolicitacaoCompras">
                                <a data-toggle="tab"
                                   href="#tab-lista-arquivos">
                                    Arquivos
                                </a>
                            </li>
                        </ul>
                        <div class="tab-content">

                            <div id="tab-dados-solicitacao" class="tab-pane active">
                                <div class="panel-body">
                                    <dados-solicitacao ref="dadosSolicitacao"
                                                       :solicitacao.sync="solicitacao"
                                                       :carregando="carregando"
                                                       :edicao="!!$route.params.id">
                                    </dados-solicitacao>
                                </div>
                            </div>
                            <div id="tab-adicionar-itens" class="tab-pane">
                                <div class="panel-body">
                                    <adicionar-item :itens-solicitacao-compra.sync="solicitacao.itensSolicitacaoCompra"
                                                    ref="adicionarItem"
                                                    :projeto="solicitacao.projeto">
                                    </adicionar-item>
                                </div>
                            </div>
                            <div id="tab-itens-solicitacao" class="tab-pane">
                                <div class="panel-body">
                                    <lista-item :itens-solicitacao-compra.sync="solicitacao.itensSolicitacaoCompra"
                                                @editarItem="editarItem">
                                    </lista-item>
                                </div>
                            </div>

                            <div id="tab-termo" class="tab-pane">
                                <div class="panel-body">
                                    <termo :solicitacao.sync="solicitacao"
                                           ref="termo">
                                    </termo>
                                </div>
                            </div>

                            <div id="tab-adicionar-arquivos" class="tab-pane">
                                <div class="panel-body">
                                    <adicionar-arquivos ref="adicionarArquivos">
                                    </adicionar-arquivos>
                                </div>
                            </div>
                            <div id="tab-lista-arquivos" class="tab-pane">
                                <div class="panel-body">
                                    <lista-de-arquivos :arquivos="arquivos"
                                                       @download="download"
                                                       ref="listaArquivos">
                                    </lista-de-arquivos>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>

            <div class="alert alert-warning" role="alert">
                <div class="row">
                    <div class="col-xs-12">
                        <div class="form-group no-margins">
                            <dl class="col-xs-12">
                                <dt>Observação</dt>
                                <dd>
                                    Verifique na aba "Itens da solicitação" se todos os itens foram inseridos ou alterados antes de clicar no botão salvar.
                                </dd>
                            </dl>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-xs-12">
                    <div class="form-group">
                        <router-link class="btn btn-default" :to="{ name: 'solicitacao-compra' }" active-class="">
                            <i class="fa fa-arrow-left"></i>
                            Voltar
                        </router-link>

                        <button id="salvar"
                                type="button"
                                class="btn btn-primary"
                                @click="salvar"
                                data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Salvando...">
                            <i class="fa fa-save"></i>
                            Salvar
                        </button>
                    </div>
                </div>
            </div>

        </form>
    </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-compra/componentes/SolicitacaoCompraForm.vue